import { Box, SxProps, Theme, Typography } from '@mui/material';
import { RootSx, SubTitleSx, TitleSx } from './NotImplementedProps';
import PageUnderDevelopment from '../../assets/icons/PageUnderDevelopment';

type Props = {
  sx?: SxProps<Theme>;
};

function NotImplemented({ sx }: Props) {
  return (
    <Box
      sx={[RootSx, ...(Array.isArray(sx) ? sx : [sx])]}
      className="not-implemented"
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <PageUnderDevelopment sx={{ fontSize: 180 }} />
      </Box>

      <Typography sx={TitleSx}>Feature Not Implemented</Typography>
      <Typography sx={SubTitleSx}>
        This feature has not been implemented yet.
      </Typography>
    </Box>
  );
}

export default NotImplemented;
